import { useMemo } from 'react';

/**
 * useWrappedToolbar Hook
 * 
 * Wraps the toolbar to add FOKUS saving functionality.
 * When Flow FOKUS mode changes, it saves to either:
 * - Custom view (if one is active)
 * - Default view settings (if on default Flow view)
 * 
 * NOTE: This does NOT handle tab history sync anymore.
 * Tab history is managed explicitly in selectViewWithUrlSync and selectViewByTypeWithUrlSync
 * in useSprintDetailFeatures.js to ensure customViewId is always passed correctly.
 */
const useWrappedToolbar = ({
  toolbar,
  activeCustomView,
  customViewSettings,
}) => {
  // Wrap toolbar methods to add syncing functionality
  const wrappedToolbar = useMemo(() => ({
    ...toolbar,
    // Wrap handleFocusModeChange to save Flow FOKUS
    handleFocusModeChange: (isActive, taskId, isTransition, allFocusedIds) => {
      // Call original handler
      toolbar.handleFocusModeChange(isActive, taskId, isTransition, allFocusedIds);
      // Save FOKUS state - handleFlowFokusChange handles both custom and default views
      customViewSettings.handleFlowFokusChange(isActive, taskId, isTransition, allFocusedIds);
    },
  }), [toolbar, customViewSettings]);

  return wrappedToolbar;
};

export default useWrappedToolbar;
